import {
  getTemplateById,
  renderTemplate,
} from "../../constants/MessageActions";
import { ConversationModal, MessageModal, MyMessages } from "../../interfaces/MessageObject";
import { getRequest, postRequest } from "../http/httpRequest";

async function getAllArchivedMessages(): Promise<ConversationModal[]> {
  const endpoint = "/api/v1/communication/getAllArchivedMessages";
  const includeBearerToken = true;
  const response = await getRequest(endpoint, includeBearerToken);
  const data = await response.json();
  return data;
}

async function getAllMessages(): Promise<MyMessages> {
  const endpoint = "/api/v1/communication/getAllMessages";
  const includeBearerToken = true;
  const response = await getRequest(endpoint, includeBearerToken);
  const data = await response.json();
  return data;
}





async function sendMessage(
  messageContent: string,
  offerId: string,
  messageTemplate: string,
): Promise<MessageModal> {
  const endpoint = "/api/v1/communication/sendMessage";
  const payload = { messageContent, offerId, messageTemplate };
  const includeBearerToken = true;
  const response = await postRequest(endpoint, payload, includeBearerToken);
  const data = await response.json();
  return data;
}

async function makeOffer(offerPrice: number, productId: string): Promise<any> {
  const endpoint = "/api/v1/communication/makeOffer";
  const template = getTemplateById("B_MAKE_OFFER");
  if (!template) {
    throw new Error("Template not found for B_MAKE_OFFER");
  }
  const messageContent = renderTemplate(template.text, {
    offerPrice: offerPrice,
  });
  const messageTemplate = template.id;
  const payload = { offerPrice, productId, messageContent, messageTemplate };
  const includeBearerToken = true;
  const response = await postRequest(endpoint, payload, includeBearerToken);
  const data = await response.json();
  return data;
}

async function makeOfferInactive(offerId: string): Promise<any> {
  const endpoint = "/api/v1/communication/makeOfferInactive";
  const payload = { offerId };
  const includeBearerToken = true;
  const response = await postRequest(endpoint, payload, includeBearerToken);
  const data = await response.json();
  return data;
}

// Persists this device's Firebase Cloud Messaging token for the current user
// (added to profiles.fcmTokens — multi-device). Called after notification
// permission is granted.
async function registerUserFcmToken(token: string): Promise<any> {
  const endpoint = "/api/v1/communication/registerUserFcmToken";
  const payload = { token };
  const includeBearerToken = true;
  const response = await postRequest(endpoint, payload, includeBearerToken);
  // The endpoint may return an empty body; guard the JSON parse.
  try {
    return await response.json();
  } catch {
    return { ok: response.ok };
  }
}

// Authoritative count of conversations awaiting the current user's reply
// (other party messaged last and the user hasn't responded), counted once per
// conversation. Source of truth for the bottom-nav message badge.
async function getYetToRespondCount(): Promise<number> {
  const endpoint = "/api/v1/communication/yet-to-respond-count";
  const includeBearerToken = true;
  const response = await getRequest(endpoint, includeBearerToken);
  const data = await response.json();
  return data?.contents?.[0]?.yetToRespondCount ?? 0;
}

export default {
  getAllMessages,
  sendMessage,
  makeOffer,
  getAllArchivedMessages,
  makeOfferInactive,
  registerUserFcmToken,
  getYetToRespondCount,
};
